import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  fetchDashboardInsgihtThunk,
  fetchTopProductsThunk,
} from "./dashboard.thunk";
import { initialState } from "./dashboard.states";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDashboardInsgihtThunk.pending, (state) => {
      state.loadingDashboardInsight = true;
      state.analyzerData = initialState.analyzerData;
      state.scannerData = initialState.scannerData;
    });
    builder.addCase(
      fetchDashboardInsgihtThunk.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loadingDashboardInsight = false;
        state.analyzerData = action.payload?.analyzer;
        state.scannerData = action.payload?.scanner;
      }
    );
    builder.addCase(
      fetchDashboardInsgihtThunk.rejected,
      (state, action: PayloadAction<any>) => {
        state.loadingDashboardInsight = false;
        state.analyzerData = initialState.analyzerData;
        state.scannerData = initialState.scannerData;
      }
    );
    builder.addCase(fetchTopProductsThunk.pending, (state) => {
      state.loadingTopProducts = true;
      state.topProducts = initialState.topProducts;
    });
    builder.addCase(
      fetchTopProductsThunk.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loadingTopProducts = false;
        state.topProducts = action.payload;
      }
    );
    builder.addCase(
      fetchTopProductsThunk.rejected,
      (state, action: PayloadAction<any>) => {
        state.loadingTopProducts = false;
        state.topProducts = initialState.topProducts;
        console.error(action.payload);
      }
    );
  },
});

export const {} = dashboardSlice.actions;

export default dashboardSlice.reducer;
